import basicAppConfig from "@next-platform/client-common-core/infra/constants/basicAppConfig";
import { Button, ButtonSize, ButtonVariant, IconVariants } from "@next-platform/client-common-spicy-ui";
import { useCallback } from "react";

import { getAnalyticsDocsUrl } from "@/pages/CreatorAnalytics/utils";

const DOCS_TARGET = "_blank";
// `window.open` features must be comma-separated; "noopener noreferrer"
// (space-separated, the rel-attribute syntax) is silently ignored on most
// browsers and the new tab keeps `window.opener`, letting the docs page
// navigate this tab via tab-napping.
const DOCS_FEATURES = "noopener,noreferrer";
const ROOT_TEST_ID = "DocsHelpButton";

// TODO(igor-nextday): [NX-7407] move user-facing labels to Namespace.CreatorAnalytics i18n keys.
const HELP_LABEL = "Help";

interface IDocsHelpButtonProps {
  "data-testid"?: string;
}

const DocsHelpButton = ({ "data-testid": testId = ROOT_TEST_ID }: IDocsHelpButtonProps = {}) => {
  const applicationId = basicAppConfig.applicationId;

  const handleClick = useCallback(() => {
    const docsUrl = getAnalyticsDocsUrl(applicationId);
    const docsWindow = window.open(docsUrl, DOCS_TARGET, DOCS_FEATURES);
    // Belt and suspenders: even if a browser still honours the old features
    // string and gives us a window reference, sever the back-pointer.
    if (docsWindow) {
      docsWindow.opener = null;
    }
  }, [applicationId]);

  return (
    <Button
      data-testid={testId}
      size={ButtonSize.SMALL}
      variant={ButtonVariant.SECONDARY}
      iconStart={IconVariants.INFO}
      onClick={handleClick}
      aria-label="open-analytics-help"
    >
      {HELP_LABEL}
    </Button>
  );
};

export default DocsHelpButton;
